/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Lms.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FeatureFlagsResponse
} from '../../../types/api';

import { apiClient } from '../../client/api-client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns the feature flags evaluated for the current caller (anonymous or signed in)
 * @summary Get feature flags
 */
export const featureFlagsGet = (

 signal?: AbortSignal
) => {


      return apiClient<FeatureFlagsResponse>(
      {url: `/api/feature-flags`, method: 'GET', signal
    },
      );
    }




export const getFeatureFlagsGetQueryKey = () => {
    return [
    `/api/feature-flags`
    ] as const;
    }


export const getFeatureFlagsGetQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagsGet>>> = ({ signal }) => featureFlagsGet(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof featureFlagsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeatureFlagsGetQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagsGet>>>
export type FeatureFlagsGetQueryError = unknown


export function useFeatureFlagsGet<TData = Awaited<ReturnType<typeof featureFlagsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsGet>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsGet<TData = Awaited<ReturnType<typeof featureFlagsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof featureFlagsGet>>,
          TError,
          Awaited<ReturnType<typeof featureFlagsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeatureFlagsGet<TData = Awaited<ReturnType<typeof featureFlagsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get feature flags
 */

export function useFeatureFlagsGet<TData = Awaited<ReturnType<typeof featureFlagsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFeatureFlagsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






